module.exports = __webpack_public_path__ + "static/media/font2.2f553417.ico";